// extracted by mini-css-extract-plugin
export default {"textBlock":"style_textBlock__-7cQm"};